import { Flex, Layout, Skeleton } from "antd";
import { createStyles } from "antd-style";

const useStyles = createStyles(
  (
    { token, css },

    { zIndex }: RootHomeSkeletonProps
  ) => ({
    floatingNav: css`
      position: fixed;
      z-index: ${zIndex};
      margin-top: ${token.marginLG}px;
      margin-left: ${token.marginSM}px;
      width: 60px;
      height: calc(100vh - 48px);
      background: ${token.colorFillQuaternary};
      padding: ${token.paddingXXS}px;
      border-radius: ${token.borderRadiusLG}px;
      @media (max-width: ${token.screenMDMax}px) {
        display: none;
      }
    `,
    header: css`
      position: fixed;
      top: 0;
      z-index: ${zIndex};
      width: 100%;
      background: ${token.colorBgContainer};
      padding: ${token.paddingLG}px;
      height: 64px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid ${token.colorBorder};
    `,
    layoutContent: css`
      margin-top: 64px;
      margin-left: 70px;
      padding: ${token.padding}px;
      min-height: calc(100vh - 64px);
      @media (max-width: ${token.screenMDMax}px) {
        padding: ${token.paddingXL}px;
        margin-left: 0;
      }
    `,
  })
);

type RootHomeSkeletonProps = {
  zIndex: number;
};

export function RootHomeSkeleton({ zIndex }: RootHomeSkeletonProps) {
  const { styles } = useStyles({ zIndex });

  return (
    <>
      {/* Floating nav skeleton */}
      <Flex className={styles.floatingNav} vertical justify="space-between" align="center">
        <Flex vertical gap={8}>
          <Skeleton.Avatar active size={52} shape="square" />
          <Skeleton.Avatar active size={52} shape="square" />
          <Skeleton.Avatar active size={52} shape="square" />
        </Flex>
        <Skeleton.Avatar active size={52} shape="square" />
      </Flex>

      <Layout style={{ flexGrow: 1, minHeight: "100vh" }}>
        {/* Header skeleton */}
        <div className={styles.header}>
          <Skeleton.Input active size="default" style={{ width: "100%", maxWidth: 200 }} />
          <Flex gap={16} align="center">
            <Skeleton.Avatar active size={24} shape="circle" />
            <Skeleton.Avatar active size={24} shape="circle" />
            <Skeleton.Avatar active size={32} shape="circle" />
          </Flex>
        </div>

        {/* Content */}
        <Layout.Content className={styles.layoutContent}>
          {/* TODO: Switch skeleton based on default loaded APP */}
          <Skeleton paragraph={{ rows: 20 }} />
        </Layout.Content>
      </Layout>
    </>
  );
}
